"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeItem = exports.setItem = exports.getItem = exports.SbLocalStorage = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var SbLocalStorage = /*#__PURE__*/function () {
  function SbLocalStorage() {
    _classCallCheck(this, SbLocalStorage);

    if (!this.isSupported()) {
      console.error('localStorage is not supported.');
    }
  }

  _createClass(SbLocalStorage, [{
    key: "getItem",
    value: function getItem(key) {
      return localStorage.getItem(key);
    }
  }, {
    key: "setItem",
    value: function setItem(key, value) {
      localStorage.setItem(key, value);
    }
  }, {
    key: "removeItem",
    value: function removeItem(key) {
      localStorage.removeItem(key);
    }
  }, {
    key: "isSupported",
    value: function isSupported() {
      var test = 'sb-test';

      try {
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        return true;
      } catch (exception) {
        return false;
      }
    }
  }]);

  return SbLocalStorage;
}();

exports.SbLocalStorage = SbLocalStorage;
var localStorageInstance = new SbLocalStorage();

var getItem = function getItem(key) {
  if (localStorageInstance.isSupported()) {
    return localStorageInstance.getItem(key);
  }

  return null;
};

exports.getItem = getItem;

var setItem = function setItem(key, value) {
  if (localStorageInstance.isSupported()) {
    return localStorageInstance.setItem(key, value);
  }

  return undefined;
};

exports.setItem = setItem;

var removeItem = function removeItem(key) {
  if (localStorageInstance.isSupported()) {
    return localStorageInstance.removeItem(key);
  }

  return undefined;
};

exports.removeItem = removeItem;
//# sourceMappingURL=sb-local-storage.js.map